import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { SET_OBS_TOP_DARES_CONFIG } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { setObsTopDaresConfig } = appStoreLenses

export default config => async (dispatch, getState) => {
	const state = getState()
	const lambdaRes = await invokeApiRequest(SET_OBS_TOP_DARES_CONFIG, config, state)
	const { body } = lambdaRes

	return setObsTopDaresConfig(body, state)
}
